import React from "react";
import { Dialog, Classes } from "@blueprintjs/core";
import {useTranslation} from "react-i18next";

// Components
import { blueColor } from "../common/libs/theme-lib";
import Button from "../common/components/button";

// Actions
import {updateUserStatus} from "./users-action";
import {useDispatch} from "react-redux";

// Redux dispatch hook
const useReduxDispatch = () => {
    const dispatch = useDispatch();
    return {
        updateUserStatus: (user) => dispatch(updateUserStatus(user))
    }
};

const ActivateUserDialog = (props) => {
    const {isOpen, onClose, user} = props;

    // Redux
    const {updateUserStatus} = useReduxDispatch();

    // i18n
    const {t} = useTranslation("users");

    return (
        <Dialog
            isOpen={isOpen}
            onClose={onClose}
            lazy={true}
            style={{
                backgroundColor: "white",
                paddingBottom: "40px"
            }}
        >
            <div
                style={{margin: "20px 40px"}}
                className={Classes.DIALOG_BODY}
            >
                <h3 style={{margin: "20px 0"}}>{t("activateUserDialog.title")}</h3>
                <h4 style={{color: blueColor}}>{user.full_name}</h4>
                <p>
                    {t("activateUserDialog.userType")} <b>{user.type === "admin" ? t("userType.admin") : t("userType.client")}</b><br/>
                    {user.type === "client" && (
                        <span>{t("activateUserDialog.client")} <b>{user?.client?.name}</b></span>
                    )}
                </p>
                <p>{t("activateUserDialog.text1")}</p>
                <p>{t("activateUserDialog.text2")}</p>
            </div>
            <div
                style={{margin: "20px 40px 0 40px"}}
                className={Classes.DIALOG_FOOTER}>
                <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                    <Button
                        text={t("editUserDialog.input.cancel")}
                        action={onClose}
                        intent={"cancel"}
                        style={{
                            marginRight: "15px",
                        }}
                    />
                    <Button
                        text={t("activateUserDialog.activate")}
                        action={() => {
                            updateUserStatus({
                                _id: user._id, 
                                status: "active"
                            });
                            onClose();
                        }}
                        intent={"secondary"}
                    />
                </div>
            </div>
        </Dialog>
    );
};

export default ActivateUserDialog;